export default __webpack_public_path__ + "static/media/close-red.a989ec58.svg";